import React, { Component, Fragment } from 'react';
import { Row, Col } from 'react-bootstrap';
import Panel from '@common/externos/components/panel/panel.component';
import autoBind from 'react-autobind';
import { ddados } from '../solicitarBaixaMei.ddados';
import { connect } from '@common/components/base.component';
import DDadosItem from '@common/components/ddados/ddados.item';
import Form from '@common/externos/components/validation/form.validation';
import solicitarBaixaMeiSelector from '../store/solicitarBaixaMei.selectors';
import solicitarBaixaMeiActions from '../store/solicitarBaixaMei.actions';
import RedeSIMHeader from '../../redeSIM.header';

class Container extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  onSubmit(data) {
    this.props.solicitarBaixaMeiActions.processarSolicitarBaixaMei(data);
  }

  toggleModal() {
    this.props.solicitarBaixaMeiActions.setSolicitarBaixaMei({
      SolicitacaoBaixaMeiDados: [],
      GridSolicitarBaixaMeiPesquisa: [],
      SolicitarBaixaMeiModalToggle: false,
    });
  }

  render() {
    const { solicitarBaixaMei } = this.props.solicitarBaixaMeiSelector;
    const { Campos } = ddados;

    return (
      <Fragment>
        <RedeSIMHeader selector={solicitarBaixaMei.SolicitarBaixaMeiHeader} />
        <Form onSubmit={this.onSubmit} onCancel={this.toggleModal} fromModal={true}>
          {(form) => (
            <Fragment>
              <Panel title="Endereço" expanded={true} expandedFix={true}>
                <Row>
                  <Col lg={3}>
                    <DDadosItem name="Cep" {...Campos.Cep} state={solicitarBaixaMei.SolicitarBaixaMeiEndereco} />
                  </Col>
                  <Col lg={3}>
                    <DDadosItem name="Estado" {...Campos.Estado} state={solicitarBaixaMei.SolicitarBaixaMeiEndereco} />
                  </Col>
                  <Col lg={6}>
                    <DDadosItem name="Cidade" {...Campos.Cidade} state={solicitarBaixaMei.SolicitarBaixaMeiEndereco} />
                  </Col>
                </Row>
                <Row>
                  <Col lg={3}>
                    <DDadosItem name="Bairro" {...Campos.Bairro} state={solicitarBaixaMei.SolicitarBaixaMeiEndereco} />
                  </Col>
                  <Col lg={3}>
                    <DDadosItem
                      name="TipoLogradouro"
                      {...Campos.Tipo}
                      state={solicitarBaixaMei.SolicitarBaixaMeiEndereco}
                    />
                  </Col>
                  <Col lg={6}>
                    <DDadosItem
                      name="Logradouro"
                      {...Campos.Logradouro}
                      state={solicitarBaixaMei.SolicitarBaixaMeiEndereco}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg={3}>
                    <DDadosItem name="Numero" {...Campos.Numero} state={solicitarBaixaMei.SolicitarBaixaMeiEndereco} />
                  </Col>
                  <Col lg={9}>
                    <DDadosItem
                      name="Complemento"
                      {...Campos.Complemento}
                      state={solicitarBaixaMei.SolicitarBaixaMeiEndereco}
                    />
                  </Col>
                </Row>
              </Panel>

              <div style={{ marginTop: '20px' }}>
                <Row>
                  <Col lg={12}>
                    <DDadosItem name="Email" {...Campos.Email} state={solicitarBaixaMei.SolicitarBaixaMeiConteudo} />
                  </Col>
                </Row>
                <Row>
                  <Col lg={12}>
                    <DDadosItem
                      name="MotivoBaixa"
                      {...Campos.MotivoBaixa}
                      state={solicitarBaixaMei.SolicitarBaixaMeiConteudo}
                    />
                  </Col>
                </Row>
                <div style={{ marginTop: '-20px' }}>
                  <Row>
                    <Col lg={3}>
                      <DDadosItem
                        name="DataTerminoAtividade"
                        {...Campos.DataTerminoAtividade}
                        state={solicitarBaixaMei.SolicitarBaixaMeiConteudo}
                      />
                    </Col>
                  </Row>
                </div>
              </div>
            </Fragment>
          )}
        </Form>
      </Fragment>
    );
  }
}

export default connect({
  actions: {
    solicitarBaixaMeiActions,
  },
  selectors: { solicitarBaixaMeiSelector },
})(Container);
